var map = {
	"./add.svg": 75134,
	"./add_arrow2.svg": 88926,
	"./add_img.svg": 62594,
	"./add_imgbgc2.svg": 21772,
	"./arrow-down.svg": 52325,
	"./arrow-next.svg": 72590,
	"./arrow-pre.svg": 3732,
	"./arrowdown.svg": 51392,
	"./bell.svg": 3050,
	"./check.svg": 72179,
	"./circle-fill.svg": 7769,
	"./close.svg": 74983,
	"./copy.svg": 68898,
	"./copy2.svg": 35388,
	"./delete.svg": 55556,
	"./draw-initial.svg": 65244,
	"./edit.svg": 61593,
	"./ellip-fill.svg": 75041,
	"./eraser.svg": 41753,
	"./eye.svg": 33288,
	"./file-left.svg": 72951,
	"./file-right.svg": 38354,
	"./grid.svg": 30457,
	"./group.svg": 5818,
	"./hi.svg": 52236,
	"./highlighter.svg": 72242,
	"./import.svg": 69362,
	"./info.svg": 5489,
	"./list.svg": 77293,
	"./log_out.svg": 24028,
	"./minus-pure.svg": 49618,
	"./more.svg": 62878,
	"./moveBottom.svg": 28591,
	"./moveTop.svg": 23731,
	"./navigator.svg": 51904,
	"./no-color.svg": 86526,
	"./pencil-alt.svg": 99480,
	"./rec-fill.svg": 69697,
	"./refresh.svg": 16598,
	"./refreshht.svg": 34850,
	"./save.svg": 77854,
	"./scale_hand.svg": 16195,
	"./search.svg": 45093,
	"./select.svg": 36805,
	"./star-fill.svg": 36429,
	"./textNote.svg": 34764,
	"./trash.svg": 8737,
	"./tri-fill.svg": 45314,
	"./undo.svg": 62267
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48202;